import { DialogClose, DialogContent, DialogFooter } from '@/components/atoms/Dialog';
import { Button } from '@/components/ui/button';

interface Props {
  content: React.ReactNode;
}

export const TermsDialogContent = ({ content }: Props) => {
  return (
    <DialogContent
      noCloseBtn
      className="w-[calc(100vw-40px)] max-w-lg overflow-hidden rounded-[20px] border-0 p-6 scrollbar-hide"
    >
      <div className="max-h-[calc(100dvh-220px)] overflow-auto sm:max-h-[534px]">{content}</div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="SolidLow" height="44" className="">
            확인
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  );
};
